import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import PasswordInput from '../password/password-input';

const NewPasswordInput = ({
  value,
  onChange,
  showPassword,
  setShowPassword,
}) => {
  const passwordRequirements = [
    {
      id: 'minLength',
      text: 'a minimum 8 characters',
      test: (password) => password.length >= 8,
    },
    {
      id: 'uppercase',
      text: 'at least one uppercase letter',
      test: (password) => /[A-Z]/.test(password),
    },
    {
      id: 'lowercase',
      text: 'at least one lowercase letter',
      test: (password) => /[a-z]/.test(password),
    },
    {
      id: 'number',
      text: 'at least one number',
      test: (password) => /\d/.test(password),
    },
    {
      id: 'specialChar',
      text: 'at least one special character',
      test: (password) => /[!@#$%^&*(),.?":{}|<>]/.test(password),
    },
  ];

  return (
    <div>
      <PasswordInput
        value={value}
        onChange={onChange}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        placeholder="New Password"
        inputId="new-password-input"
        autoComplete="new-password"
      />
      <div
        style={{
          marginLeft: '0.25rem',
          marginTop: '0.5rem',
          color: '#fff',
          fontSize: '0.9rem',
          textAlign: 'left',
          lineHeight: '1.5',
        }}
      >
        <div>New password must have:</div>
        {passwordRequirements.map((requirement) => (
          <div
            key={requirement.id}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {requirement.test(value) ? (
              <FaCheckCircle
                color="#27ae60"
                style={{ marginRight: '0.5rem' }}
              />
            ) : (
              <FaTimesCircle
                color="#ba383d"
                style={{ marginRight: '0.5rem' }}
              />
            )}
            {requirement.text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewPasswordInput;
